const field = { key: "", label: "", type: "text", required: false } ;

export let buildField = () => {
    return Object.assign(JSON.parse(JSON.stringify(field)), {});
}
export let buildSectionField = () => {
    console.log(Object.assign(field, {}));
    return { title: "", type: 'section', children: [buildField()] }
}